export default __webpack_public_path__ + "static/remote_b.a44f0ffdacbb7c1a01dd512cd3583238.png";